import React from 'react';
import button from "bootstrap/js/src/button";

const BackButton = (props) => {
    const {
        onClick     = () => {},
        disabled    = false,
    } = props;

    return (
        <button onClick={() => onClick()}
                disabled={disabled}
                className={'back-button'}
        >
            <span>&larr;&nbsp;Back</span>
        </button>
    )
}

export default BackButton;
